export default __webpack_public_path__ + "static/media/add-auth-user-icon.0d147e05.svg";